module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDEzIDIwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNjODVkZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmRwcy1pY29uczwvdGl0bGU+PGcgaWQ9ImNoZXZyb24tZG93biI+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjAgOC41IDIuNSA2IDYuNSAxMCAxMC41IDYgMTMgOC41IDYuNSAxNSAwIDguNSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/components/resources/dps-icons_account-options_menu.svg
// module id = 1514
// module chunks = 0